import { useEffect, useRef, useState } from 'react';


const TimeInput = ({ value, onChange, useColon, ...props }) => {
    const [ hours, setHours ] = [ value.split(":")[0], (val) => onChange(val+":"+minutes) ];
    const [ minutes, setMinutes ] = [ value.split(":")[1], (val) => onChange(hours+":"+val) ];

    const hourInputRef = useRef(null);
    const minuteInputRef = useRef(null);

    function pad(str) {
        if(str.length == 0) return "00";
        if(str.length == 1) return "0" + str;
        return str;
    }

    const handleHourChange = (e) => {
        const inputValue = e.target.value;
        
        if(/^[0-1][0-9]$|^2[0-3]$|^[0-9]$|^$/.test(inputValue)) {
            if (inputValue.length === 2) {
                minuteInputRef.current.focus();
                minuteInputRef.current.select();
            }

            setHours(inputValue);
        } else {
            setHours(hours);
        }
    };

    const handleMinuteChange = (e) => {
        const inputValue = e.target.value;
        
        if(/^[0-9]$|^[0-5][0-9]$|^$/.test(inputValue)) {
            setMinutes(inputValue);
        } else {
            setMinutes(minutes);
        }
    };

    return (
        <div className="input row g8 center-cross" style={{ fontFamily: 'monospace', justifyContent: 'start', padding: 0, paddingInline: 8 }} {...props} >
            <div className="row g4 center-cross">
                <input
                    ref={hourInputRef}
                    value={hours}
                    type="text"
                    className="invisible"
                    maxLength="2"
                    placeholder='00'
                    style={{ width: '2ch', boxSizing: 'content-box', padding: 0 }}
                    onChange={(e) => handleHourChange(e, minuteInputRef)}
                    onBlur={(e) => { if(e.target.value.length == 1) setHours("0"+e.target.value); else if(e.target.value.length == 0) setHours("00") }}
                    onClick={(e) => e.target.select()}
                />
                {!useColon && (<p style={{ userSelect: 'none' }}>h</p>)}
            </div>
            {useColon && (<p style={{ userSelect: 'none' }}>:</p>)}
            <div className="row g4 center-cross">
                <input
                    ref={minuteInputRef}
                    value={minutes}
                    type="text"
                    className="invisible"
                    maxLength="2"
                    placeholder='00'
                    style={{ width: '2ch', boxSizing: 'content-box', padding: 0 }}
                    onChange={(e) => handleMinuteChange(e)}
                    onBlur={(e) => { if(e.target.value.length == 1) setMinutes("0"+e.target.value); else if(e.target.value.length == 0) setMinutes("00") }}
                    onClick={(e) => e.target.select()}
                />
                {!useColon && (<p style={{ userSelect: 'none' }}>min</p>)}
            </div>
        </div>
    );
};

export default TimeInput;